import { Link, LinkProps } from '@mui/material';
import { useRecordContext } from 'react-admin';

export const LabeledUrlField = ({ source, label, ...rest }: { source: string; label?: string } & LinkProps) => {
  const record = useRecordContext();

  if (!record || !source || !record[source]) {
    return <span>{label}</span>;
  }

  return (
    <Link href={record[source]} {...rest}>
      {label ?? record[source]}
    </Link>
  );
};

export default LabeledUrlField;
